import { render, staticRenderFns } from "./CreateInstitution.vue?vue&type=template&id=bee59664&scoped=true&"
import script from "./CreateInstitution.vue?vue&type=script&lang=js&"
export * from "./CreateInstitution.vue?vue&type=script&lang=js&"
import style0 from "./CreateInstitution.vue?vue&type=style&index=0&id=bee59664&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee59664",
  null
  
)

export default component.exports